<template>
  <!-- <div>
    <el-dialog title="Password Reset" :visible.sync="dialogVisible" width="30%">
      <span class="p-2">Are you sure you want to continue?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">Cancel</el-button>
        <el-button type="warning" @click="confirmReset">Confirm</el-button>
      </span>
    </el-dialog>
  </div> -->
  <transition name="fade">
    <div
      v-if="dialogVisible"
      class="bg-black fixed bg-opacity-80 inset-0 z-50 h-screen w-full"
    >
      <div
        class="fixed center-h-v bg-white rounded-md sm:w-1/3 w-full shadow-2xl"
      >
        <div class="flex justify-between items-center border-b-1.5">
          <p class="text-base p-2 font-semibold">Reset password</p>
          <img
            class="h-6 mr-2 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
            src="@/assets/icons/cross-white.png"
            @click="cancel"
          />
        </div>
        <p class="text-left text-sm py-5 p-2">
          Are you sure you want to continue?
        </p>
        <div class="p-2">
          <span slot="footer" class="dialog-footer flex mr-auto">
            <el-button @click="cancel">Cancel</el-button>
            <el-button type="warning" @click="confirmReset">Confirm</el-button>
          </span>
        </div>
      </div>
    </div>
    >
  </transition>
</template>

<script>
export default {
  name: "PasswordRestDialog",
  props: {
    open: Boolean,
    callback: Function,
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  watch: {
    open: function (newVal) {
      this.dialogVisible = newVal;
    },
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
    },

    confirmReset() {
      this.dialogVisible = false;
      if (this.callback) {
        this.callback(true);
      }
    },
    cancel() {
      this.dialogVisible = false;
      if (this.callback) {
        this.callback(false);
      }
    },
  },
};
</script>
